// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","image":"Loader_image__gsJwL"};